import { useState, useEffect, useContext } from "react";
import { useWeb3React } from "@web3-react/core";
import { CHAIN } from "../../utils/constants/config";
import { AppContext } from "./connectors";
const useGetAddress = (chain) => {
  const [address, setAddress] = useState(null);
  const { account } = useWeb3React();
  const { cardanoAddress: wallet } = useContext(AppContext);

  useEffect(() => {
    if (chain == CHAIN.EITH) {
      setAddress(account);
    } else if (chain == CHAIN.CARDANO) {
      setAddress(wallet);
    }
  }, [account, wallet, chain]);

  return address ?? null;
};
export default useGetAddress;
